import React from "react";

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...this.state })
    })
      .then(() => this.setState({ loaded: true }))
      .catch(() => this.setState({ loaded: false }));

    e.preventDefault();
  };
  render() {
    return (
      <form
        id="contactusform"
        method="post"
        onSubmit={this.handleSubmit}
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <div
          id="success"
          className="no-margin-lr"
          style={{ display: "none" }}
        />
        <input
          name="name"
          type="text"
          required="true"
          placeholder="Your Name"
          onChange={this.handleChange}
        />
        <input
          name="email"
          type="email"
          placeholder="Your Email"
          required="true"
          onChange={this.handleChange}
        />
        <textarea
          placeholder="Your Message"
          required="true"
          name="comment"
          defaultValue={""}
          onChange={this.handleChange}
        />
        <button
          id="contact-us-button"
          type="submit"
          className="highlight-button-dark btn btn-small button xs-margin-bottom-five"
          disabled={this.state.loaded}
        >
          {this.state.loaded ? `Message Sent!`: `Send message`}
        </button>
      </form>
    );
  }
}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/ContactForm.js